jQuery(function ($) {
	const base = "gc-navbar";

	$(`.${base}__burger`).on("click", function () {
		$(`.${base}`).toggleClass(`${base}--active`);
	});
});
